import { asyncAction, action } from 'now-frontend-shared/utils/actions';

// async actions
export const getSellerAgreementTemplate = asyncAction('sellerAgreementTemplate/GET_SELLER_AGREEMENT_TEMPLATE');

// sync action
export const reset = action('sellerAgreementTemplate/RESET');
